module.exports = __webpack_public_path__ + "assets/img/jlj-zy.657e100e.png";